import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Tekst intro
 * Slug: text_intro
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.text_intro-layout');

	layouts.forEach((layout) => {
		const contentCol = layout.querySelector(".content-col");
		gsap.from(contentCol, {
			opacity: 0,
			scrollTrigger: {
				trigger: contentCol,
				markers: false,
				start: "top bottom-=10%"
			}
		})
	});
});
